const timeFmt = new Intl.DateTimeFormat("ko-KR", { hour: "numeric", minute: "2-digit" });
const dayFmt = new Intl.DateTimeFormat("ko-KR", { month: "long", day: "numeric", weekday: "short" });
const dayYearFmt = new Intl.DateTimeFormat("ko-KR", { year: "numeric", month: "long", day: "numeric", weekday: "short" });
const fullFmt = new Intl.DateTimeFormat("ko-KR", { dateStyle: "long", timeStyle: "short" });

/** "오후 3:12" */
export const formatTime = (iso: string) => timeFmt.format(new Date(iso));

/** 같은 해면 "10월 17일 (금)", 아니면 연도까지. 오늘·어제는 말로. */
export function formatDay(iso: string, now = new Date()): string {
  const d = new Date(iso);
  const key = dayKey(d);
  if (key === dayKey(now)) return "오늘";
  const y = new Date(now);
  y.setDate(now.getDate() - 1);
  if (key === dayKey(y)) return "어제";
  return (d.getFullYear() === now.getFullYear() ? dayFmt : dayYearFmt).format(d);
}

export const formatFull = (iso: string) => fullFmt.format(new Date(iso));

/** 앞으로의 시각: "오늘 오후 3:42", "내일 오전 9:00", "10월 20일 (화) 오전 9:00" */
export function formatWhen(iso: string, now = new Date()): string {
  const d = new Date(iso);
  const tomorrow = new Date(now);
  tomorrow.setDate(now.getDate() + 1);
  const day = dayKey(d) === dayKey(now) ? "오늘" : dayKey(d) === dayKey(tomorrow) ? "내일" : (d.getFullYear() === now.getFullYear() ? dayFmt : dayYearFmt).format(d);
  return `${day} ${timeFmt.format(d)}`;
}

export function dayKey(d: Date): string {
  return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
}

/** 초대 만료 등: "6일 남음" */
export function formatRemaining(iso: string, now = Date.now()): string {
  const ms = new Date(iso).getTime() - now;
  if (ms <= 0) return "만료됨";
  const hours = Math.floor(ms / 3_600_000);
  return hours >= 24 ? `${Math.floor(hours / 24)}일 남음` : `${Math.max(1, hours)}시간 남음`;
}

/** 알림·검색 결과에서 메시지로 가는 주소 (스레드 답글이면 스레드 창, 아니면 본문에서 강조) */
export function messagePath(place: { channelId: number | null; conversationId: number | null }, messageId: number, rootId: number | null): string {
  const base = place.channelId !== null ? `/c/${place.channelId}` : `/d/${place.conversationId}`;
  return `${base}${rootId ? `/t/${rootId}` : ""}?m=${messageId}`;
}
